
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiGenericLineStraight as ObiGenericLineStraightElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-generic-line-straight.js';
 
 
 

 
 export const ObiGenericLineStraight = createComponent({
   react: React,
   tagName: 'obi-generic-line-straight',
   elementClass: ObiGenericLineStraightElement,
   events: {
     
   }
  });
 
 